import { signInWithPopup, signOut } from 'firebase/auth';
import { auth, googleProvider } from 'services/firebase';

// Thin wrappers around Firebase Auth so the UI never touches the SDK directly.
// The user's profile document is created server-side by the `createUserProfile`
// Cloud Function (auth onCreate), not here.
export function signInWithGoogle() {
  return signInWithPopup(auth, googleProvider);
}

export function signOutUser() {
  return signOut(auth);
}
